export var FolderType;
(function(FolderType) {
    FolderType["PAID"] = "paid";
    FolderType["WATCHERS"] = "watchers";
    FolderType["REGULAR"] = "regular";
})(FolderType || (FolderType = {}));

//# sourceMappingURL=types.js.map